var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useRouter } from "next/router";
import Button from "core/Button";
var StyleReset = function () {
    var router = useRouter();
    var query = router.query, pathname = router.pathname;
    var handleClick = function () {
        // Create a copy of the query object
        var updatedQuery = __assign({}, query);
        // Remove specified params
        delete updatedQuery["style"];
        delete updatedQuery["weight"];
        // Update the URL without the removed params
        router.replace({
            pathname: pathname,
            query: updatedQuery,
        });
    };
    return (_jsx("div", { children: _jsx(Button, { onClick: handleClick, styleType: "cta", children: "Clear Filters" }) }));
};
export default StyleReset;
